module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./public/app/modules/my-content/view-content/view-content.component.html
// module id = ./public/app/modules/my-content/view-content/view-content.component.html
// module chunks = main